import { makeAutoObservable, runInAction } from "mobx";
import { LobbyApi } from "./LobbyApi";
import type { InfluencerCard } from "./LobbyType";

export type LobbyPageMode = "follows" | "arena";

export class LobbyModel {
  cards: InfluencerCard[] = [];
  loaded = false;
  loadError: string | null = null;
  readonly mode: LobbyPageMode;
  /** mode === "arena" 时有效 */
  readonly arenaSpaceId: string;

  constructor(mode: LobbyPageMode, arenaSpaceId: string) {
    this.mode = mode;
    this.arenaSpaceId = arenaSpaceId;
    makeAutoObservable(this);
  }

  async load() {
    this.loadError = null;
    try {
      const rows =
        this.mode === "follows"
          ? await LobbyApi.listMySubscribedInfluencerCards()
          : await LobbyApi.listInfluencerCards(this.arenaSpaceId);
      runInAction(() => {
        this.cards = rows;
        this.loaded = true;
      });
    } catch (e) {
      runInAction(() => {
        this.loadError = e instanceof Error ? e.message : "加载失败";
        this.loaded = true;
      });
    }
  }
}
